export default __webpack_public_path__ + "media/images/chrome-share-icon-e7be7a2c.png";